import { z } from 'zod';

/** URL filter token for projects without assigned labels. */
export const PROJECT_LABEL_NONE = 'none';

export const PROJECT_LABEL_COLORS = [
  '#C9DFD8',
  '#C5D9EB',
  '#DDD0EB',
  '#F0C9D1',
  '#F3D4B6',
  '#E8DFB2',
  '#D9D9D9',
] as const;

export const createProjectLabelSchema = z.object({
  name: z.string().trim().min(1).max(40),
  color: z.enum(PROJECT_LABEL_COLORS),
});
export type CreateProjectLabel = z.infer<typeof createProjectLabelSchema>;
export type ProjectLabel = CreateProjectLabel & { id: string };
export type ProjectLabels = {
  labels: ProjectLabel[];
  assignments: Record<string, string[]>;
};
export const projectLabelIdsSchema = z.array(z.string().uuid()).max(100);
